import React from 'react';
import {
  Table,
  Text,
  Image,
  TouchableOpacity,
  View,
} from '../../../app-components';
import { adminsListUri } from '../../../Queries/admin';
import { ROUTES } from '../../../Lib/constants';
import { editRecord } from '../../../images';
import vars from '../../../theme/vars';
import { shorten } from '../../../Lib/helpers';
const { headings } = vars;

const tableItems = {
  lg: {
    columns: [
      {
        header: 'Username',
        type: 'text',
        // field: 'username',
        width: 300,
        render: (props) => {
          return (
            <Text
              style={{
                fontSize: 16,
                fontFamily: 'Mulish-Medium',
              }}>
              {shorten(props?.item?.username, 22)}
            </Text>
          );
        },
      },
      {
        header: 'Email Id',
        type: 'text',
        width: 300,

        render: (props) => {
          return (
            <Text
              style={{
                fontSize: 16,
                fontFamily: 'Mulish-Medium',
              }}>
              {shorten(props?.item?.email, 18)}
            </Text>
          );
        },
      },
      {
        header: 'Status',
        type: 'text',
        width: 300,

        render: ({ item }) => {
          return (
            <View
              style={{
                width: 100,
                borderRadius: 15,
                backgroundColor:
                  item?.status === 'Active' ? '#2cbcb1' : '#009dcc',
                alignItems: 'center',
                paddingTop: 5,
                paddingBottom: 5,
              }}>
              <Text style={{ ...headings.h8, color: '#FFF' }}>
                {item?.status}
              </Text>
            </View>
          );
        },
      },
      {
        header: 'Actions',
        type: 'text',
        width: 150,

        render: () => (
          <TouchableOpacity>
            <Image
              style={{
                height: 24,
                width: 24,
              }}
              source={editRecord}
            />
          </TouchableOpacity>
        ),
        action: ({ item }) => ({
          type: 'link',
          link: {
            view: ROUTES.editAdmin.name,
            params: { item: { ...item } },
          },
        }),
      },
    ],
  },
};

export default Table({
  reloadEvent: ROUTES.adminData.name,
  uri: adminsListUri,
  ...tableItems,
  action: ({ item }) => ({
    type: 'link',
    link: {
      view: ROUTES.ViewAdmin.name,
      params: { item: { ...item }, editable: false },
    },
  }),
});
